import { TFunction } from 'i18next'

import { TransactionsSalesTaxPaymentsActionItem } from '../types/salesTaxPaymentsActionItem'

export enum TransactionsSalesTaxPaymentsActionType {
  VoidPayment = 'voidPayment',
}

interface GetSalesTaxPaymentsActionsProps {
  t: TFunction
}

export const getSalesTaxPaymentsActions = ({ t }: GetSalesTaxPaymentsActionsProps) => {
  const items: TransactionsSalesTaxPaymentsActionItem[] = [
    {
      children: t('transactions.table.static_actions.sales_tax_payments.void_payment'),
      id: TransactionsSalesTaxPaymentsActionType.VoidPayment,
      value: TransactionsSalesTaxPaymentsActionType.VoidPayment,
    },
  ]

  return items
}
